import React from "react";

function Sleake() {
  return (
    <div class="row">
      <div class="col-md-12 margin_60 description">
        <div class="row">
          <div class="col-md-7 description">
            <h2 class="margin_30"> Adista - Nancy</h2>
            <p>
              {/* - Résolution rapide des incidents clients
              <br />- Pratique régulière des commandes Cisco et Linux - Sécurité
              Parfeu (Fortinet / Stormshield), Vpn et routage Réseaux */}
              <b>CDI · 6 ans 3 moisCDI · 6 ans 3 mois</b>
              <br />
              <br />
              <small>Maxéville, Grand Est, France</small>
              <br />
              <br />
              <b>Technicien IT - Support One</b>
              <br />
              <small>
                oct. 2024 - aujourd’hui · 1 moisDe oct. 2024 à aujourd’hui · 1
                mois
              </small>
              <br />
              <br />
              <br />
              <b>Technicien IT</b>
              <br />
              <small>août 2018 - aujourd’hui · 6 ans 3 mois </small>
              <br />
              <br />
              ℹ️ Résolution de problème+ contacte client
              <br />
              <br />
              - Résolution rapide des incidents clients.
              <br />
              - Pratique régulière des commandes Cisco et Linux.
              <br />
              - Sécurité Parfeu (Fortinet / Stormshield), Vpn et routage
              Réseaux.
              <br />
              <br />
              <b>Compétences :</b> Fortinet · Cisco · Stormshield · Routeurs
              Cisco · Huawei
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sleake;
